<template>
  <div class="job-offer-letter" :style="backgroundStyle">
    <!-- Header Top Right: Barcode & Ref -->
    <div class="header-metadata text-end">
      <div class="barcode-area mb-0">
        <span class="barcode-font">||| |||| |||| |||| |||| ||||</span>
        <div class="ref-text text-uppercase">{{ details?.metadatos_documento?.codigo_referencia }}</div>
      </div>
      
      <div class="title-area mt-3">
        <h4 class="document-title mb-0">CARTA DE POSTULACIÓN LABORAL</h4>
        <div class="date-line py-1 border-top-dark">
          <span class="text-sm">Fecha: {{ details?.metadatos_documento?.fecha_emision }}</span>
        </div>
      </div>
    </div>

    <!-- Letter Body -->
    <div class="letter-body pt-2">
      <p class="mb-1">
        Estimado (a) <strong>{{ (details?.datos_postulado?.nombre_completo || '').toUpperCase() }}</strong>
      </p>

      <p class="mb-2 text-justify">
        A continuación se detallará la oferta laboral a la cual se postula el solicitante en mención. Leer todos los detalles y consultar cualquier inquietud con su abogado de inmigración asignado.
      </p>

      <div class="section-postulado mb-2">
        <h6 class="font-weight-bold text-uppercase mb-2">DATOS DEL POSTULADO</h6>
        <div class="row no-gutters">
          <div class="col-12 mb-0"><strong>Nombre Completo:</strong> {{ details?.datos_postulado?.nombre_completo }}</div>
          <div class="col-12 mb-0"><strong>Número de Identificación:</strong> {{ details?.datos_postulado?.numero_identificacion }}</div>
          <div class="col-12 mb-0"><strong>Teléfono Contacto:</strong> {{ details?.datos_postulado?.telefono_contacto }}</div>
          <div class="col-12 mb-0"><strong>Nacionalidad:</strong> {{ details?.datos_postulado?.nacionalidad }}</div>
        </div>
      </div>

      <div class="section-cargo mb-2">
        <h6 class="font-weight-bold text-uppercase">
          NOMBRE DE LA OFERTA LABORAL: {{ (details?.detalles_oferta?.nombre_cargo || '').toUpperCase() }}
        </h6>
      </div>

      <div class="section-detalles mb-2">
        <div class="detail-item mb-1"><strong>Nombre de la Empresa:</strong> {{ details?.detalles_oferta?.nombre_empresa }}</div>
        <div class="detail-item mb-1"><strong>Promedio Salarial:</strong> ${{ details?.detalles_oferta?.promedio_salarial_anual?.toLocaleString('en-US') }},00 USD Anual.</div>
        <div class="detail-item mb-1"><strong>Tipo de empleo:</strong> {{ details?.detalles_oferta?.tipo_empleo }}.</div>
        <div class="detail-item mb-1"><strong>Tipo de contrato:</strong> {{ details?.detalles_oferta?.tipo_contrato }}.</div>
        <div class="detail-item mb-1"><strong>Ubicación Del Cargo:</strong> {{ details?.detalles_oferta?.ubicacion_cargo }}</div>
      </div>

      <div class="section-tareas mb-2">
        <h6 class="font-weight-bold mb-2">Detalles de la oferta laboral:</h6>
        <ul class="bullet-list pl-4">
          <li v-for="(task, index) in details?.detalles_oferta?.tareas_responsabilidades" :key="'task-'+index">
            {{ task }}
          </li>
        </ul>
      </div>

      <div class="section-beneficios mb-2">
        <h6 class="font-weight-bold mb-1">Beneficios:</h6>
        <ul class="bullet-list pl-4">
          <li class="mb-0">Gana ${{ details?.beneficios?.pago_semanal_total?.toLocaleString('en-US') }},00 USD por semana en salario y beneficios.</li>
          <li v-for="(benefit, index) in details?.beneficios?.beneficios_adicionales" :key="'benefit-'+index">
            {{ benefit }}
          </li>
        </ul>
      </div>

      <div class="section-closing mt-2 text-sm-custom">
        <div class="mb-0"><strong>Horas previstas por semana:</strong> {{ details?.detalles_oferta?.horas_semanales }} Horas por semana.</div>
      </div>
    </div>
    
    <!-- Optional Footer Line (If not in background) -->
    <div class="letter-footer-line mt-auto">
      <hr class="dark-line">
    </div>
  </div>
</template>

<script>
export default {
  name: "JobOfferLetterPreview",
  props: {
    details: {
      type: Object,
      required: true
    }
  },
  computed: {
    backgroundStyle() {
      return {
        backgroundImage: `url(${require('@/assets/img/background_letter.png')})`,
        backgroundSize: '100% 100%',
        width: '210mm',
        height: '297mm',
        padding: '25mm 20mm 15mm 20mm',
        margin: '0 auto',
        boxShadow: '0 0 10px rgba(0,0,0,0.1)',
        backgroundColor: 'white',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column'
      };
    }
  }
}
</script>

<style scoped>
.job-offer-letter {
  font-family: 'Open Sans', 'Helvetica', 'Arial', sans-serif;
  color: #1a1a1a;
  line-height: 1.25;
  text-align: left;
}
.barcode-font {
  font-family: 'Courier New', Courier, monospace;
  font-weight: bold;
  letter-spacing: -2px;
  font-size: 14pt;
}
.ref-text {
  font-size: 7pt;
  font-family: monospace;
  letter-spacing: 1px;
}
.document-title {
  color: #0b1d3f;
  font-size: 16pt;
  font-weight: 900 !important;
}
.border-top-dark {
  border-top: 1px solid #0b1d3f;
  width: 100%;
}
.header-metadata {
  align-self: flex-end;
  width: auto;
}
.letter-body, .text-sm-custom {
  font-size: 10pt;
}
.text-justify {
  text-align: justify;
}
.bullet-list {
  list-style-type: disc;
  margin: 0;
  padding-left: 1.5rem;
}
.bullet-list li {
  margin-bottom: 2px;
}
.dark-line {
  border-top: 1px solid #1a1a1a;
  margin-top: 40px;
}
h6 {
  font-size: 10.5pt;
  margin-bottom: 0.3rem;
}
strong {
  font-weight: 700 !important;
}
</style>
